
import { SellersApiRemoteService } from '../../Services/api/sellers/sellers-service'
import { ICreateSellersPayload, ISellerEntity } from '../../Services/api/sellers/sellers.interface'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class CreateSellersUseCase
implements IFormUsecase<ICreateSellersPayload, ISellerEntity> {
  constructor (private readonly SellersApi: SellersApiRemoteService) {}
    

  public async handle (data: ICreateSellersPayload): Promise<Result<ISellerEntity>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.SellersApi.create(data)

      if (response.isFailure) {
        return response
      }
    
      const list = response.getValue()

      if(!list) return response
    
      return Result.ok(list)
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
